export default __webpack_public_path__ + "static/media/line-footer.f1bef4a7.svg";